const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('chrome') > -1) {
    // Chrome
  } else if (ua.indexOf('safari') !== -1) {
    if (ua.indexOf('chrome') <= -1) {
      return true;
    }
  }
  return false;
};

const isWebKitIOS = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('applewebkit') >= -1) {
    if (ua.indexOf('iphone') >= 0) {
      return true;
    }
    if (ua.indexOf('ipad') >= 0) {
      return true;
    }
    if (ua.indexOf('chrome') >= 0) {
      return false;
    }
    if (ua.indexOf('safari') >= 0) {
      return true;
    }
  }
  return false;
};

export {
  isSafari,
  isWebKitIOS,
};
